import { TagArquivo } from '../../models/integracao-arquivos/tag-arquivo.model';

export class CategoriaArquivoRequest {
  public idCategoriaArquivo: number;
  public nome: string;
  public observacao: string;
  public listaTagArquivo: TagArquivo[];
}
